module.exports = __webpack_public_path__ + "assets/images/pages/medipremium/medipremium-4-fg.png?d60b434f";